const state = {
  sms: [],
  smsPageCurrent: null,
  smsPageCount: null,
};

export default state;
